<template>
  <div
    v-if="entryDiscountTimeLimit"
    class="te-bg-time-limit-banner mx-auto mb-12 w-full rounded p-4 text-center text-white lg:w-3/4"
    style="max-width: 720px; background-size: 180px"
  >
    <h3
      class="co-display-10 font-bold tracking-[0.15em]"
      style="color: #ff3"
    >
      <span class="pr-2">割引特典</span>受講料<span class="co-display-7 font-bold">10,000</span>円引き
    </h3>
    <span class="mb-0">今、お申し込みいただくと</span>
    <span class="block sm:inline">下記の受講料から10,000円割引！</span>
    <span class="co-display-13 block">※学生は5,000円引き</span>
  </div>
</template>

<script lang="ts">
import type { StringDate } from 'types/constantType'

interface Props {
  entryDiscountTimeLimit: StringDate
}

const options = {
  props: {
    entryDiscountTimeLimit: {
      type: String,
    } as PropOptions<StringDate>,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-time-limit-banner {
  background-color: #ff802b;
  background-repeat: no-repeat;
  background-position: 3% center, 97% center;
  background-size: auto, auto;
  @media (min-width: 768px) {
    background-image: url('~/assets/images/Te/TeCommon/Price/TimeLimit/bg-countdown-1.png'),
      url('~/assets/images/Te/TeCommon/Price/TimeLimit/bg-countdown-2.png');
  }
}
</style>
